import PrimaryInnerGlowButton from '@/components/buttons/primary';
import SecondaryDefaultButton from '@/components/buttons/secondary';
import SimpleCTAFooter from '@/components/footers/SimpleCTAFooter';
import Link from '@/components/Link';
import { ModuleSimpleCtaFooterFragment } from '@/graphql';
import { getSingleLink } from '@/lib/craft-utils';
import gtm from '@/lib/gtm';
import { maybeNotSet } from '@/lib/typescript-helpers';
import { FC, ReactNode } from 'react';

export interface SimpleCTAFooterModuleProps {
  props: CraftModuleFragment<ModuleSimpleCtaFooterFragment>;
  ctaOverride?: ({ ctas }: { ctas: ReactNode }) => ReactNode;
}

const SimpleCTAFooterModule: FC<SimpleCTAFooterModuleProps> = ({ props, ctaOverride }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  const { heading } = props;
  const primaryCta = getSingleLink(props.primaryCta);
  const secondaryCta = getSingleLink(props.secondaryCta);

  const primaryCtaNode: ReactNode = primaryCta ? (
    <Link href={primaryCta.url}>
      <PrimaryInnerGlowButton
        id="footer-primary-cta"
        as="a"
        onClick={() => {
          gtm.track('click', {
            category: `Footer Module | ${maybeNotSet(heading)}`,
            element_type: 'button',
            element_label: `Primary CTA | ${maybeNotSet(primaryCta.text)}`,
          });
        }}
      >
        {primaryCta.text}
      </PrimaryInnerGlowButton>
    </Link>
  ) : null;

  const secondaryCtaNode: ReactNode = secondaryCta ? (
    <Link href={secondaryCta.url}>
      <SecondaryDefaultButton
        id="footer-secondary-cta"
        as="a"
        onClick={() => {
          gtm.track('click', {
            category: `Footer Module | ${maybeNotSet(heading)}`,
            element_type: 'button',
            element_label: `Secondary CTA | ${maybeNotSet(secondaryCta.text)}`,
          });
        }}
      >
        {secondaryCta.text}
      </SecondaryDefaultButton>
    </Link>
  ) : null;

  let ctas: ReactNode = (
    <>
      {primaryCtaNode}
      {secondaryCtaNode}
    </>
  );

  if (ctaOverride) {
    ctas = ctaOverride({ ctas });
  }

  return <SimpleCTAFooter heading={heading ?? ''} ctas={ctas} background={props.background ?? undefined} />;
};

export default SimpleCTAFooterModule;
